import { Server } from 'mock-socket';
import config from "./config.json";
import { compileTemplate } from "./utils";
import messages from "./data/platform/notification-messages.json";
import { sleep } from './utils'

const { websocket } = compileTemplate(config)

let sendMesageInitiated = false;

/** * Sends messages over the WebSocket connection.
 * This function continuously sends messages from the predefined messages array
 * to the WebSocket server at specified intervals.
 * @param {Object} socket - The WebSocket connection object.
 * @returns {Promise<void>} - A promise that resolves when all messages have been sent.
 * @throws {Error} - Throws an error if the WebSocket connection is not established.
 * */
const sendMessages = async (socket) => {
    if (sendMesageInitiated) {
        console.warn('Websocket Message sending already initiated, skipping...');
        return;
    }
    sendMesageInitiated = true;

    while (true) {
        const message = compileTemplate(messages.pop());
        console.log('Websocket Sending message:', message);
        if (!!message) { socket.send(JSON.stringify(message)); }
        else {
            sendMesageInitiated = false;
            console.warn('No more messages to send, stopping...');
            break;
        }
        await sleep(websocket.interval || 20000);
    }
}

window.websocketServerInstance = null;
window.intervalId = null;

/** * Initializes the WebSocket server.
 * This function sets up a WebSocket server that listens for incoming connections
 * and sends predefined messages at specified intervals.
 * @returns {void}
 * @throws {Error} - Throws an error if the WebSocket server cannot be initialized.
 * */
const initWebsocketServer = () => {
    if (websocket && websocket.enabled) {
        const wsUrl = process.env.REACT_APP_UI_NOTIFICATION_WS + websocket.url;
        console.log('WebSocket server URL:', wsUrl);
        window.websocketServerInstance = new Server(wsUrl);

        window.websocketServerInstance.on('connection', socket => {
            console.log('WebSocket server connection received:', socket);
            console.log('WebSocket server connection established');
            sendMessages(socket);

            socket.on('message', data => {
                console.log('Received message:', data);
                socket.send('test message from mock server');
            });
            socket.on('error', data => {
                console.log('Websocket error server message:', data);

            });
            socket.on('close', data => {
                console.log('Websocket close server message:', data);

            });
        });
        window.websocketServerInstance.on('error', error => { console.log('WebSocket server error:', error); });
        console.log('WebSocket server initialized at:', wsUrl);
    }
}
export { initWebsocketServer };